import { capitalize } from "@mui/material/utils";
import { unstable_composeClasses, generateUtilityClass } from "@mui/material";
function getButtonUtilityClass(slot) {
  return generateUtilityClass("TrueButton", slot);
}
const useUtilityClasses = (ownerState) => {
  const {
    color = "initial",
    fullWidth,
    size = "medium",
    variant = "text",
    classes
  } = ownerState;
  const slots = {
    root: [
      "root",
      `${variant}Size${capitalize(size || "")}`,
      color === "inherit" && "colorInherit",
      fullWidth && "fullWidth"
    ],
    label: ["label"],
    startIcon: ["startIcon", `iconSize${capitalize(size || "")}`],
    endIcon: ["endIcon", `iconSize${capitalize(size || "")}`]
  };
  const composedClasses = unstable_composeClasses(slots, getButtonUtilityClass, classes);
  return {
    ...classes,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...composedClasses
  };
};
export {
  getButtonUtilityClass,
  useUtilityClasses
};
//# sourceMappingURL=button.classes.js.map
